import React from "react";
import { useEffect, useState } from "react";
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Tooltip, Zoom } from "@material-ui/core";

const BackToTop = () => {
  // The back-to-top button is hidden at the beginning
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 300) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);

  // This function will scroll the window to the top 
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // for smoothly scrolling
      block: "center",
    });
  };

  return (
    <>
      {showButton && (
        <Tooltip TransitionComponent={Zoom} title="Back To Top" arrow>
          <button onClick={scrollToTop} className="back-to-top">
          <KeyboardArrowUpIcon />
        </button>
        </Tooltip>
      )}
    </>
  );
};

export default BackToTop;